import { State, Action, StateContext, Selector, Store } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { SetUser, SetAllUsers, RemoveUser, SetMaxUsers, SetDataLoaded } from './users.actions';
import { IUser } from './users.model';

export class UsersStateModel {
  users: IUser[] = [];
  candidates: IUser[] = [];
  maxUsers: number = 0;
  dataLoaded: boolean = false;
}

@State<UsersStateModel>({
  name: 'StateUsers',
  defaults: new UsersStateModel()
})

@Injectable()
export class UsersState {
  constructor(private store: Store) {}

    @Selector()
    static getUsers(state: UsersStateModel): IUser[] {
      return state.users.filter(user => user.candidate === false);
    }

    @Selector()
    static getCandidates(state: UsersStateModel): IUser[] {
      return state.users.filter(user => user.candidate === true); 
    }

    @Selector()
    static getUsersDataLoaded(state: UsersStateModel): boolean {
        return state.dataLoaded;
    }

    @Selector()
    static getMaxUsers(state: UsersStateModel): number {
      return state.maxUsers;
    }

    @Action(SetDataLoaded)
    setLoading({ patchState }: StateContext<UsersStateModel>, { loading }: SetDataLoaded): void {
      patchState({
        dataLoaded: loading
      });
    }

    @Action(SetUser)
    setUser({getState, patchState, dispatch}: StateContext<UsersStateModel>, { user, patchNewState  }: SetUser): void {
      const state = getState();
      const originalState = getState();
  
      const existingUserIndex: number = state.users.findIndex((inUuser: IUser) => inUuser.id === user.id);
      if (existingUserIndex >= 0) {

        state.users[existingUserIndex] = {
          ...user,
          creationDate: state.users[existingUserIndex].creationDate
        };
      } else {
        state.users.push(user);
      }
    
      if (patchNewState) {
        patchState({
          users: [...state.users]
        });
      }
    }
  
    @Action(SetAllUsers)
    setAllUsers(stateContext: StateContext<UsersStateModel>, { users }: SetAllUsers): void {
      const state = stateContext.getState();
  
      users.forEach((zone: IUser) => {
        this.setUser(stateContext, new SetUser(zone, false));
      });
      stateContext.patchState({
        users: [...state.users],
        dataLoaded: true
      });
    }
  
    @Action(RemoveUser)
    removeUser({getState, patchState }: StateContext<UsersStateModel>, { userId }: RemoveUser): void {
      patchState({
        users: getState().users.filter((user: IUser) => user.id !== userId)
      });
    }

    @Action(SetMaxUsers)
    SetMaxUsers({ patchState }: StateContext<UsersStateModel>, { maxUsers }: SetMaxUsers): void {
      patchState({
        maxUsers: maxUsers
      });
    }
  
}
